
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-md px-4">
        <h1 className="text-5xl font-bold mb-6 text-primary">404</h1>
        <p className="text-2xl font-semibold mb-3">Page not found</p>
        <p className="text-muted-foreground mb-8">
          The page you are looking for doesn't exist or has been moved to another location.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="outline" onClick={() => window.history.back()} className="flex items-center gap-2">
            <ArrowLeft size={16} />
            <span>Go Back</span>
          </Button>
          <Button asChild className="flex items-center gap-2">
            <a href="/">
              <Home size={16} />
              <span>Return Home</span>
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
